module.exports = __webpack_public_path__ + "img/satisfaction-title-sm.91ffd367.png";